import React from "react";
import { useSelector } from "react-redux";
import { classNames } from "../../utils/common";

import Participant from "../Participant";

const Participants = ({ showChat }) => {
  const participants = useSelector((state) => state.participants);
  const room = useSelector((state) => state.room);
  const userData = useSelector((state) => state.auth.userData);

  const orderedParticipants = Object.values(participants).sort((a, b) => {
    return a.display.localeCompare(b.display);
  });

  return (
    <div
      className={classNames(
        "grid items-center grid-cols-2 lg:grid-cols-4 gap-2 row-gap-3 p-2",
        !showChat && "lg:grid-cols-6"
      )}
    >
      {orderedParticipants.map((participant) => {
        let {
          id,
          display,
          isPublisher,
          isLocalScreen,
          stream_timestamp,
          speaking,
          focus,
          video,
        } = participant;

        return (
          <Participant
            key={id}
            id={id}
            username={display}
            isPublisher={isPublisher}
            isLocalScreen={isLocalScreen}
            streamReady={stream_timestamp}
            speaking={speaking}
            focus={focus}
            video={video}
            isAdmin={userData.data && userData.data.UserRole === "Instructor"}
          />
        );
      })}
    </div>
  );
};

export default Participants;
